// =====================================================
// Lizzi V2 — entry point
// =====================================================
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles.css';

// Apply the persisted theme to <html> before first paint so screens rendered
// before AppShell mounts (e.g. the login screen) get the design tokens too.
(() => {
  let theme = 'dark';
  try { theme = localStorage.getItem('lizzi:theme') || 'dark'; } catch (e) {}
  document.documentElement.setAttribute('data-theme', theme);
})();


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
